import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import {
  CircuitContext,
  SET_SELECTED_CIRCUIT_DATA,
  SET_SHOW_HIDE_CIRCUIT_POPUP,
  UPDATE_CHANGE_CIRCUIT_DATA,
} from '../context/context'
import TextArea from '../../../common/TextArea'
import SelectInput from '../../../common/SelectInput'
import useDebouncedValue from '../../../../utils/common_function'

const CircuitForm = ({ onDataSave }) => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(CircuitContext)
  const [signalOptions, setSignalOptions] = useState([])
  const [searchSignal, setSearchSignal] = useState('')
  const debouncedSearchSignal = useDebouncedValue(searchSignal, 1000)

  useEffect(() => {
    getSignaltData(searchSignal)
  }, [debouncedSearchSignal])

  const saveCircuitData = async (e) => {
    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)

    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/circuit/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      onDataSave(res?.status, 'Data Successfully Saved')
      if (res?.status) {
        dispatch({
          type: UPDATE_CHANGE_CIRCUIT_DATA,
          data: state?.selectedObject,
        })
        closePopUp()
      }
    } else {
      let res = await postRequest(`/api/circuit/`, formData)
      onDataSave(res?.status, 'Data Successfully Saved')
      if (res?.status) {
        closePopUp()
      }
    }
  }

  const closePopUp = () => {
    dispatch({
      type: SET_SHOW_HIDE_CIRCUIT_POPUP,
      data: false,
    })
  }

  const getSignaltData = async (value = '') => {
    let res = await getRequest(
      `/api/signal/?vehicle=${vehicle}&search=${value}&limit=10`
    )
    setSignalOptions(res.results)
  }

  return (
    <Modal
      onClose={() => {
        closePopUp()
      }}
      show={state?.showCircuitFormPopup}
    >
      <ModalHeader className={'text-white'}>Circuit's</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveCircuitData(e)
          }}
        >
          <input
            type="hidden"
            value={state?.selectedObject?.import_file}
            name="import_file"
          />
          <div className="flex">
            <InputText
              name="name"
              value={state?.selectedObject?.name}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    name: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Circuit Name'}
              type="text"
            />
            <InputText
              name="str1"
              value={state?.selectedObject?.str1}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    str1: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Str 1'}
              type="text"
              isRequired={false}
            />
            <InputText
              name="str2"
              value={state?.selectedObject?.str2}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    str2: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Str 2'}
              type="text"
              isRequired={false}
            />
          </div>
          <div className="flex">
            <InputText
              name="str3"
              value={state?.selectedObject?.str3}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    str3: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Str 3'}
              type="text"
              isRequired={false}
            />
            <InputText
              name="cat1"
              value={state?.selectedObject?.cat1}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    cat1: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Cat 1'}
              type="text"
              isRequired={false}
            />
            <InputText
              name="cat2"
              value={state?.selectedObject?.cat2}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    cat2: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Cat 2'}
              type="text"
              isRequired={false}
            />
          </div>
          <div className="flex w-full text-white">
            <TextArea
              name="description"
              value={state?.selectedObject?.description}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    description: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Circuit Description'}
              type="text"
              className="w-full"
            />
            <SelectInput
              name="signal_name"
              options={signalOptions}
              label="Signal Type"
              isRequired={false}
              value={
                state?.selectedObject?.signal_name?.id
                  ? state?.selectedObject?.signal_name
                  : null
              }
              onChange={(e) => {
                dispatch({
                  type: SET_SELECTED_CIRCUIT_DATA,
                  data: {
                    ...state?.selectedObject,
                    signal_name: e,
                  },
                  showFormPopup: true,
                })
              }}
              optionLabel="name"
              optionValue="id"
              onInputChange={(value) => {
                setSearchSignal(value)
              }}
            />
          </div>
          <div className="flex justify-end">
            <div className="w-1/3 px-2 mt-5">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end pr-2`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save Circuit'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default CircuitForm
